import React from 'react';
import { EventOverviewTabProps } from 'common/module_interface/events/EventsDrawerRegistry';
import EntityCard from 'common/design-system/components-v2/EntityCard/EntityCard';
import { BlockInfoProps } from 'common/design-system/components-v2/BlockInfo/BlockInfo.types';
import RemediationPanel from 'common/components/RemediationPanel/RemediationPanel';
import { Command } from 'common/design-system/components-v2';
import { getCheckpointUrl } from 'common/components/Forms/urls';
import { IFindingModelOriginString } from 'common/components/Findings/Findings.interface';

const IARuleCardComponent: React.FC<EventOverviewTabProps> = ({ finding: event }) => {
    const buildEntityCardBlocks = () => {
        const getRulesetUrl = () => {
            if (!event.bundleId) return undefined;
            switch (event.origin) {
                case IFindingModelOriginString.ImageAssurance:
                    return `/workload/rulesets/${event.bundleId}`;
                default:
                    return undefined;
            }
        };

        const blocks: (BlockInfoProps & { isVisible?: boolean })[] = [
            {
                title: 'Ruleset',
                info: event.bundleName,
                copyable: true,
                internalUrl: getRulesetUrl(),
                isVisible: !!event.bundleName,
            },
            {
                title: 'RuleID',
                info: event.ruleId,
                copyable: true,
                externalUrl: `${getCheckpointUrl('GSL_KNOWLEDGE_BASE')}/${event.ruleId}.html`,
                isVisible: !!event.ruleId && Number(event.bundleId) < 0,
            },
            {
                title: 'Rule Description',
                info: event.description,
                copyable: true,
                fullWidth: true,
                maxWidth: undefined,
                isVisible: !!event.description,
            },
            {
                title: 'Remediation',
                fullWidth: true,
                maxWidth: undefined,
                info: <RemediationPanel remediation={event.remediation || ''} />,
                isVisible: !!event.remediation,
            },
            {
                title: 'Remediation Actions',
                fullWidth: true,
                maxWidth: undefined,
                info: (
                    <RemediationPanel
                        remediation={event.remediationActions.reduce((acc, action) => `${acc}/n${action}`, '')}
                    />
                ),
                isVisible: event.remediationActions.length > 0,
            },
            {
                title: 'GSL',
                fullWidth: true,
                maxWidth: undefined,
                info: <Command text={event.ruleLogic} />,
                isVisible: !!event.ruleLogic,
            },
        ];

        return blocks.filter((block) => block.isVisible).map((block) => ({ ...block, isVisible: undefined }));
    };

    return (
        <EntityCard
            initialShowMoreState={true}
            disableShowMore={true}
            cardTitle='Rule'
            blocks={buildEntityCardBlocks()}
        />
    );
};

export default IARuleCardComponent;
